const positionToClassMap = {
  bottom: 'c-tool-tip--bottom',
  left: 'c-tool-tip--left',
  right: 'c-tool-tip--right',
  top: 'c-tool-tip--top',
};

export const TOOLTIP_POSITIONS = Object.keys(positionToClassMap);
export const TOOLTIP_CLASS_MAP = {
  position: positionToClassMap,
};
